import { Event, EventOfficial } from "../../../models";
import {
    IonCol,
    IonItem,
    IonLabel,
    IonList,
    IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { getEventOfficialsByEventId } from "../../../utilities/eventOfficial/EventOfficial";
import Spinner from "../../Spinners/Spinner";
import moment from "moment";

interface _Props {
    event: Event
}

const EventDisplayOfficials: React.FC<_Props> = ({event}) => {

    const [eventOfficials, setEventOfficials] = useState<(EventOfficial | null)[] | null | undefined>(event.officials || undefined);
    const [isLoading, setIsLoading] = useState(false);

    async function getHorseShowOfficials(eventId: string) {
        setIsLoading(true);
        const queryResult = await getEventOfficialsByEventId(eventId);
        if (queryResult.isSuccess) {
            const officials: EventOfficial[] = queryResult.result;

            // Sort them in the order in which they were created (first created -> last created)
            const sorted = officials.sort(function(a: EventOfficial, b: EventOfficial): number {
                const aMoment: any = a.createdAt ? moment(a.createdAt) : null;
                const bMoment: any = b.createdAt ? moment(b.createdAt) : null;
                const aVal: string = aMoment ? aMoment.format("YYYYMMDDHHmmss") : "0";
                const bVal: string = bMoment ? bMoment.format("YYYYMMDDHHmmss") : "0";
                return aVal.localeCompare(bVal);
            });

            setEventOfficials(sorted);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (event) {
            getHorseShowOfficials(event.id);
        }
    }, [event]);
    return (
        <>
            {isLoading ? 
                <IonRow className="ion-justify-content-center">
                    <IonCol className="ion-text-center">
                        <Spinner />
                    </IonCol>
                </IonRow>
                :   
                <>
                     {eventOfficials && eventOfficials.length ?
                        <>
                            <IonRow>
                                <IonCol>
                                    <IonList className="bg-white">
                                        {eventOfficials.map((official, index) => (
                                            <IonItem key={index}>
                                                <IonLabel>
                                                    <IonRow>
                                                        <IonCol sizeXs="12" sizeMd="6">
                                                            <h3 className="ion-text-wrap text-darker">{official && official.name}</h3>
                                                        </IonCol>
                                                        <IonCol sizeXs="12" sizeMd="6">
                                                            <h4 className="ion-text-wrap text-darker">{official && official.position}</h4>
                                                        </IonCol>
                                                    </IonRow>
                                                </IonLabel>
                                            </IonItem>
                                        ))}
                                    </IonList>
                                </IonCol>
                            </IonRow>
                        </>
                        :
                        <>
                            <IonRow>
                                <IonCol>
                                    <IonItem>
                                        <IonLabel><h3>No officials listed.</h3></IonLabel>
                                    </IonItem>
                                </IonCol>
                            </IonRow>
                        </>
                    }
                </>
            }
        </>
    );
};

export default EventDisplayOfficials;